'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'user-gear';
var width = 640;
var height = 512;
var aliases = ["user-cog"];
var unicode = 'f4fe';
var svgPathData = 'M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM32 480l319 0c15.6 13.1 36.9 13.7 53 4.8l0 .9c0 9.2 2.7 18.5 7.9 26.3L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304l91.4 0c11.8 0 23.4 1.2 34.5 3.3c-1.6 13.7 3.2 26.6 11.6 36.1c-14.5-4.8-30-7.4-46.2-7.4l-91.4 0c-80 0-145 64.3-146.3 144zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM463.3 238.4c-3.1 16.6-14 29.5-26.6 36.7c-13 7.4-30 9.9-46 3.7l-17.2 30.5C386.3 320.7 392 337 392 351.7s-5.7 31-18.5 42.4l17.2 30.5c15.9-6.3 33-3.7 46 3.7c12.6 7.2 23.6 20.1 26.6 36.7l33.7 0c3-16.6 13.9-29.5 26.5-36.7c12.9-7.4 30-9.9 45.9-3.6l17.2-30.5c-12.8-11.4-18.5-27.7-18.5-42.4s5.7-31 18.5-42.4l-17.2-30.5c-15.9 6.3-32.9 3.7-45.9-3.6C510.8 268 499.9 255 497 238.4l-33.7 0zm43.5-32c11.8 0 21.4 9.6 21.4 21.4l0 1.6c0 7.5 4.6 14.2 11.1 18c6.5 3.7 14.5 4.2 21 .3l1.8-1c10.7-6.3 24.4-2.6 30.5 8.2L619 301.7c5.7 10.2 2.3 23.1-7.8 29c-7.3 4.3-11.2 12.6-11.2 21s3.9 16.7 11.2 21c10 5.9 13.5 18.8 7.8 29l-26.4 46.9c-6.1 10.8-19.9 14.5-30.5 8.2l-1.8-1c-6.5-3.8-14.5-3.4-21 .3c-6.5 3.7-11.1 10.4-11.1 18l0 1.6c0 11.8-9.6 21.4-21.4 21.4l-53.4 0c-11.7 0-21.3-9.5-21.3-21.3l0-1.4c0-7.6-4.6-14.4-11.3-18.2c-6.6-3.8-14.7-4.2-21.2-.3l-1.6 1c-10.7 6.3-24.4 2.6-30.5-8.2L341 401.7c-5.7-10.2-2.3-23.1 7.8-29c7.3-4.3 11.2-12.5 11.2-21s-3.9-16.7-11.2-21c-10-5.9-13.5-18.8-7.8-29l26.4-46.9c6.1-10.8 19.9-14.5 30.5-8.2l1.6 1c6.5 3.9 14.6 3.4 21.2-.3c6.6-3.8 11.3-10.6 11.3-18.2l0-1.4c0-11.7 9.5-21.3 21.3-21.3l53.4 0zM424.1 351.7a56 56 0 1 1 112.1 0 56 56 0 1 1 -112.1 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserGear = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;